import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import customerLoginStyles from './CustomerLogin.module.css';

export function CustomerLogin() {
  const { t } = useTranslation();
  return (
    <button className={customerLoginStyles.button}>
      <Link to='#'>{t('buttons:login')}</Link>
    </button>
  );
}
